import Modal from './Modal'
import ConfirmDeleteModal from './ConfirmDeleteModal'

Modal.ConfirmDelete = ConfirmDeleteModal

export default Modal
